// extracted by mini-css-extract-plugin
export default {"circle-progress-container":"CircleProgress_circle-progress-container__Gj5cx"};